export const GreenIcon: React.FC<React.SVGAttributes<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="currentColor"
    viewBox="0 0 256 256"
    {...props}
  >
    <path d="M43.69,246.03h-16.86V9.97h202.33l-48.9,75.88,48.9,75.88H43.69v84.31h0ZM43.69,144.86h154.53l-38.19-59.01,38.19-59.01H43.69v118.03h0Z" />
  </svg>
);
